import { calc, em, important, percent } from 'csx';
import { TEAL_PRIMARY } from 'src/utils/Style/Theme';
import { style } from 'typestyle';

const visualizeContainer = style({
  $debugName: 'visualize-container',
});

const visualizeButtonWidth = 10;
const visualizeButtonContainerMargin = 0.5;
const lineGraphClassName = 'visualize-line-chart';
const visualizeGraphsContainer = style({
  $debugName: 'visualize-graph',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  $nest: {
    [`.${lineGraphClassName}`]: {
      width: calc(`${percent(100)} - ${em(visualizeButtonWidth + 2 * visualizeButtonContainerMargin)}`),
      flexGrow: 1,
    },
    section: {
      display: 'flex',
    },
  },
});

const visualizeButtonContainer = style({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: 'auto',
  marginTop: 'auto',
  paddingLeft: 10,
  minWidth: 130,
  maxWidth: 130,
  paddingBottom: '4rem',
});

const getVisualizeChartItem = (selected: boolean) => {
  const color = selected ? TEAL_PRIMARY : '#cccccc';
  return style({
    color,
    fontSize: 12,
    fontWeight: 'bold',
    cursor: 'pointer',
    height: 30,
    $nest: {
      '&::before': {
        height: 12,
        width: 12,
        marginRight: 5,
        backgroundColor: color,
        display: 'inline-block',
        borderRadius: '50%',
        content: '" "',
        top: 1,
        position: 'relative',
      },
    },
  });
};

const barGraphContainer = style({
  height: 120,
  flexGrow: 1,
  width: '100%',
  $nest: {
    ['* > svg']: {
      overflow: 'visible',
    },
    ['* > .highcharts-container']: {
      overflow: important('visible'),
    },
  },
});

const metricLineGraphContainer = style({
  $debugName: 'metricLineGraphContainer',
  display: 'flex',
});

const lineGraphContainer = style({
  width: `calc(100% - ${visualizeButtonWidth + 2 * visualizeButtonContainerMargin}rem)`,
  flexGrow: 1,
});

export {
  visualizeContainer,
  visualizeGraphsContainer,
  visualizeButtonContainer,
  lineGraphClassName,
  barGraphContainer,
  metricLineGraphContainer,
  lineGraphContainer,
  getVisualizeChartItem,
};
